<template>
  <div>

    <div class="flex flex-wrap -mx-2">
      <div class="w-full lg:w-1/3 xl:w-1/4 px-2">
        <div class="box">
          <vehicle-information
            :vehicle="vehicle"
            :edit="true"
            @updated="getVehicle"
          ></vehicle-information>


          <div v-if="hasPermission('customer.view')">
            <p class="text-lg text-theme-darker light:text-theme-lighter my-4 border-b border-theme-200 light:border-theme-600">
              Customer information
            </p>
            <contact-information
              v-if="vehicle.contact"
              :contact="vehicle.contact"
              contact-type="customer"
              :edit="hasPermission('customer.edit')"
              :link-to-contact="true"
              @updated="getVehicle"
            ></contact-information>
          </div>
        </div>
      </div>
      <div class="w-full lg:w-2/3 xl:w-3/4 px-2" v-if="hasPermission('job.view')">
        <div class="box">
          <p class="text-lg text-theme-darker light:text-theme-lighter my-4 border-b border-theme-200 light:border-theme-600">
            Job history
          </p>
          <job-list v-if="vehicle.id" :vehicleID="vehicle.id" :buttonNew="false"></job-list>
        </div>
      </div>
    </div>

  </div>
</template>


<script>
import axios from 'axios'
import { mapGetters } from 'vuex'
const ContactInformation = resolve => require(['@/components/pages/ContactInformation'], resolve)
const VehicleInformation = resolve => require(['@/components/pages/VehicleInformation'], resolve)
const JobList = resolve => require(['@/components/pages/jobs/List'], resolve)

export default {
  name: 'vehicle-details',
  components: {
    ContactInformation,
    VehicleInformation,
    JobList,
  },
  data() {
    return {
      vehicleID: this.$route.params.vehicleID,
      vehicle: {},
      prints: {
        remarks: null,
      },
    }
  },
  computed: {
    ...mapGetters({
      Countries: 'countries/countries',
      CountryByID: 'countries/countryByID',
      config: 'config/config',
      hasPermission: 'user/hasPermission',
    })
  },
  mounted() {
    this.getVehicle()
    this.$EventBus.$on('vehicleRemarks.updated', (remarks) => this.setRemarks(remarks))
  },
  destroyed() {
    this.$EventBus.$off('vehicleRemarks.updated')
  },
  methods: {
    setStatus(status) {
      this.$swal.fire({
        title: 'Set vehicle as "' + status + '"',
        text: 'Are you sure?',
        type: 'question',
        showCancelButton: true,
      })
        .then((result) => {
          if (result.value) {
            this.vehicle.status = status
            this.updateVehicle()
          }
        })
    },
    setRemarks(remarks) {
      this.vehicle.remarks = remarks
      this.updateVehicle()
    },
    updateVehicle() {
      return axios.put('vehicles/' + this.vehicleID, this.vehicle)
    },
    getVehicle() {
      axios.get('vehicles/' + this.vehicleID)
        .then((response) => {
          const vehicle = response.data

          this.vehicle = Object.assign({}, vehicle)
        })
        .catch((error) => {
          console.log(error.response)
          this.$swal.fire({
            title: 'Vehicle not found',
            type: 'warning',
          })
            .then(() => {
              // this.$router.push('/vehicle/list')
            })
        })
    },
    createInvoice() {
      this.vehicle.invoices.push({
        contact_id: this.vehicle.contact.id,
        type: 'purchases',
        created_at: this.$moment().format(this.config.dateTimeFormats.api),
      })
      this.updateVehicle().then(this.getVehicle)
    },
  }
}
</script>
